import { useState } from "react";
import axios from "axios";

function EditDepartment({department,onClose}){

const [departmentName,setDepartmentName]=useState(
department.department_name
);

const [description,setDescription]=useState(
department.description || ""
);

const updateDepartment=async(e)=>{

e.preventDefault();

try{

const token=
localStorage.getItem("token");

const response=await axios.post(

"https://saleupcall.com/api/Department/edit-department.php",

{

id:department.id,

department_name:departmentName,
description

},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

alert(
"Department Updated"
);

onClose();

}
else{

alert(
response.data.message
);

}

}
catch(error){

console.log(error);

}

};

return(

<form onSubmit={updateDepartment}>

<div className="row">

<div className="col-md-12 mb-3">

<input
className="form-control form-control-sm"
placeholder="Department Name"
value={departmentName}
onChange={(e)=>
setDepartmentName(
e.target.value
)
}
/>

</div>

<div className="col-md-12 mb-3">

<textarea
className="form-control form-control-sm"
rows="3"
placeholder="Description"
value={description}
onChange={(e)=>
setDescription(
e.target.value
)
}
/>

</div>

</div>

<div className="text-end">

<button
className="btn btn-primary btn-sm"
>

<i className="bi bi-check-lg me-1"></i>

Update

</button>

</div>

</form>

);

}

export default EditDepartment;